import { cookie as cookieLite } from 'browser-cookie-lite'
import cx from 'classnames'
import * as React from 'react'

import { times } from '../../icons'
import type { BreakingNewsItemViewModel } from '../../view-models/BreakingNewsItemViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import { trackEvent } from '../../utils/gtag'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import Paragraph from '../Paragraph/Paragraph'
import styles from './newsTicker-style.css'

type Props = {
  items: Array<BreakingNewsItemViewModel>
  header: string
  className?: string
  breakingNewsLink?: LinkViewModel
}
type State = {
  tickerWidth: number
  gridWidth: number
  contentFits: boolean
  showContent: boolean
  isOpen: boolean
}

class NewsTicker extends React.Component<Props, State> {
  static displayName = 'NewsTicker'
  static defaultProps = {}
  state = {
    tickerWidth: 0,
    gridWidth: 0,
    contentFits: true,
    showContent: false,
    isOpen: false,
  }

  componentDidMount() {
    if (!this.hasAcceptedCookies()) {
      this.setState({
        isOpen: true,
      })
    }
  }

  getWidth = (node: any) => {
    if (node) {
      const tickerWidth = node.getBoundingClientRect().width
      const gridWidth = node.parentNode.getBoundingClientRect().width
      const contentFits = tickerWidth <= gridWidth - 160 // 160 is the btn width

      this.setState({
        tickerWidth,
        gridWidth,
        contentFits,
        showContent: true,
      })
    }
  }
  hasAcceptedCookies = () => {
    return typeof window !== 'undefined' && cookieLite('breaking-news')
  }
  handleClose = () => {
    // add cookie so it doesnt show on every refresh and close
    // expires after 24 hrs
    cookieLite('breaking-news', true, 86400000, '/')
    this.setState({
      isOpen: false,
    })
    const eventMetaClose = {
      event: 'breaking-news',
    }
    trackEvent(eventMetaClose)
  }
  renderTicker = () => {
    const { items } = this.props
    const { contentFits, tickerWidth } = this.state
    const animationDuration = tickerWidth / 25
    const animationDelay = animationDuration / 2

    return (
      <React.Fragment>
        <div
          className={styles.ticker_1}
          style={{
            animationDuration: animationDuration + 's',
          }}
        >
          {items.map((item) => (
            <Paragraph
              className={cx(styles.tickerItem, items.length === 1 && styles.lastItem)}
              size="small"
              marginBottom="none"
              key={item.text}
            >
              {item.text}
            </Paragraph>
          ))}
        </div>
        <div
          className={styles.ticker_2}
          style={{
            animationDuration: animationDuration + 's',
            animationDelay: animationDelay + 's',
          }}
        >
          {!contentFits &&
            items.map((item) => (
              <Paragraph
                className={styles.tickerItem}
                size="small"
                marginBottom="none"
                key={`${item.text}_2`}
              >
                {item.text}
              </Paragraph>
            ))}
        </div>
      </React.Fragment>
    )
  }

  render() {
    const { items, header, className, breakingNewsLink } = this.props
    const { contentFits, showContent, isOpen } = this.state
    const eventMetaLink = {
      event: 'breaking-news',
      eventData: breakingNewsLink ? breakingNewsLink.href : '',
    }
    if (!items || !isOpen) return null

    return (
      <div className={cx(styles.tickerContainer, className && className)}>
        <div className={styles.polygonHolder}>
          <button className={styles.polygon} onClick={this.handleClose}>
            <span>{header}</span>
            <span>
              <Icon iconSrc={times} width="8px" height="16px" />
            </span>
          </button>
        </div>
        <div
          className={cx(
            styles.ticker,
            !contentFits ? styles.dynamic : styles.static,
            showContent && styles.showContent,
          )}
          ref={this.getWidth}
        >
          {breakingNewsLink && breakingNewsLink.href ? (
            <Link href={breakingNewsLink.href} className={styles.pointer} eventMeta={eventMetaLink}>
              {this.renderTicker()}
            </Link>
          ) : (
            this.renderTicker()
          )}
        </div>
      </div>
    )
  }
}

export default NewsTicker